<template>
  <!-- Notas de tipos de tamaño (size):
    md: Tamaño medio / pequeño (se usa por defecto, esta en la mayoría de dialogos, utilizado con poco contenido)
    fs: Tamaño full screen (utilizado para panel de ayuda y licencia de uso)
    lg: Tamaño grande para casos con mucho contenido (utilizado para panel de ayuda y licencia de uso, excepcional por control de altura)
    lg-fix-h: Tamaño grande con fix de altura, no gestiona height, necesita ajustarse un maximo dentro del componente que lo usa
   -->
  <transition name="tranOpacity">
    <div
      v-if="isOpen"
      class="modal-overlay"
      @click="closeDialog"
    >
      <transition name="slideAside">
        <div class="container shadow-md" 
          :class="size === 'sm' 
            ? 'container-width-sm' 
            :size === 'md' 
              ? 'container-width-md' 
              : size === 'fs'
                ? 'container-width-fs'
                : 'container-width-lg'"
          @click.stop 
          v-if="secondTransition">
          <div class="flex flex-col dark:bg-darkblue-900"
            :class="size === 'md' || size === 'sm' 
              ? 'overflow-y-auto h-full' 
              : size !== 'lg-fix-h' 
                ? 'overflow-y-hidden h-full'
                : 'overflow-y-hidden'">
            <header class="sticky top-0 flex-none z-10">
              <slot name="header" />
            </header>
            <div class="d-flex flex-row bg-white dark:bg-darkblue-900"
              :class="size === 'md' || size === 'sm' 
                ? 'max-height-main h-full' 
                : size !== 'lg-fix-h'
                 ? 'h-full'
                 : ''">
              <slot name="main" />
            </div>
          </div>
          <footer class="flex flex-col lg:flex-row items-center justify-between space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
            <slot name="footer" />
          </footer>
          <UtilKeys v-if="closable" @keyup.esc="closeDialog"/>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import UtilKeys from '@/components/utilities/UtilKeys'
export default {
  name: 'base-dialog-button',
  components: {
    UtilKeys
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
    },
    closable: {
      type: Boolean,
      default: true,
    }
  },
  data () {
    return {
      secondTransition: true
    }
  },
  watch: {
    isOpen: {
      deep: true,
      immediate: true,
      handler: 'watchisOpenHandler'
    },
  },
  methods: {
    closeDialog: function () {
      if (this.closable) {
        if (this.isOpen) this.$emit('closeDialog')
      }
    },
    watchisOpenHandler: async function () {
      const self = this
      if (self.secondTransition) self.secondTransition = !self.secondTransition
      else {
        // self.secondTransition = !self.secondTransition
        setTimeout(() => {
          self.secondTransition = !self.secondTransition
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #00000088;
  z-index: 2020;
}
.container {
  left:0;
  right:0;

  margin-left: auto;
  margin-right: auto;
  margin-bottom: auto;
  position: relative;

  min-width: 320px;
  z-index: 101;

  background: white;
}
.container-width-sm{
  margin-top: 200px;
  width: 20%;
}
.container-width-md{
  margin-top: 150px;
  width: 40%;
}
.container-width-lg{
  margin-top: 100px;
  width: 60%;
}
.container-width-fs{
  margin-top: 0;
  height: calc(100% - 64px);
  width: 100%;
}

.slideAside-enter-active,
.slideAside-leave-active {
  transition: all 0.25s;
  transform: translateY(0%);
  opacity: 1;
}
.slideAside-enter,
.slideAside-leave-to {
  transition: all 0.25s;
  transform: translateY(-100%);
  opacity: 0;
}
.tranOpacity-enter-active,
.tranOpacity-leave-active {
  transition: all 0.25s;
  opacity: 1;
}
.tranOpacity-enter,
.tranOpacity-leave-to {
  transition: all 0.25s;
  opacity: 0;
}
.max-height-main{
  max-height: 400px;
}
</style>
